module.exports = __webpack_public_path__ + "img/icn_check_hv_touhatsu.1f004850.png";